









































import { Component, Prop, Model, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { Patient } from '@/types/user'
import Form from '@/mixins/form'

export type Props = {
  patient: Patient | undefined
  show: boolean
}

@Component({
  components: {
    TextInput: () => import('@/components/common/inputs/TextInput.vue'),
    CheckboxInput: () => import('@/components/common/inputs/CheckboxInput.vue'),
    SearchField: () => import('./InviteWorkerSearchField.vue')
  }
})
export default class InviteWorkerModalForm extends mixins(Form) {
  @Model('change', { type: Boolean }) show!: boolean
  @Prop(Object) readonly props!: Props

  input = {
    email: '',
    allow: false
  }

  get patient() {
    return this.props.patient
  }

  @Watch('show')
  handleChangeShowingStatus(show: boolean) {
    if (!show) {
      this.input.email = ''
      this.input.allow = false
    }
  }

  handleWorkerSelect(id: number) {
    this.input.email = String(id)
  }

  handleSearchChange(text: string) {
    this.input.email = text
  }

  async handleSubmit() {
    if (this.validator.hasAnyError()) {
      return
    }
    try {
      let isId = false
      const invite: {
        inviteeEmail?: string
        inviteeUser?: number
      } = {}
      if (/\d+/.test(this.input.email)) {
        invite.inviteeUser = Number(this.input.email)
        isId = true
      } else {
        invite.inviteeEmail = this.input.email
      }
      await this.$api.invitation.create({
        payload: {
          patient: (this.patient as Patient).id,
          isAdmin: this.input.allow,
          ...invite
        }
      })
      this.$emit('submit')
      this.$emit('added')
    } catch (error) {
      console.error(error)
    }
  }
}
